export default __webpack_public_path__ + "static/media/ResumeV2.573f57d4.pdf";